import api from '~/api';
import Partner from '~/routes/__auth/_shared/data/models/partner.model';
import User from '~/routes/__auth/_shared/data/models/user.model';
import { PartnerStatusMap } from '~/routes/__auth/_shared/data/requests/auth.request';
import type { VerifyResponse } from '../dtos/partnerResponse';

export type LoginCredentials = { email: string };

export const sessionRequest = async (credentials: LoginCredentials) => {
  await api.post<null>('/v6/sessions/request/email?web_client=partners_portal', credentials);
  return null;
};

export const validateMagicTokenRequest = async (token: string) => {
  await api.post<null>('/v6/sessions/validate_magic_token', { magic_token: token });
  return null;
};

export const verifySessionCodeRequest = async (
  code: string,
  magic_token: string
): Promise<{ user: User; partners: Partner[] }> => {
  const { data } = await api.post<VerifyResponse>('/v6/session/verify?web_client=partners_portal', {
    code,
    magic_token,
  });
  const user = new User(
    data.user_id,
    data.user_first_name,
    data.user_last_name,
    data?.user_profile_photo_medium || null
  );

  const partners = (data?.partners || [])
    .map(
      (partner) =>
        new Partner(
          partner.partner_id,
          partner.partner_name,
          PartnerStatusMap[partner.partner_status]
        )
    )
    .filter((partner) => partner.isAccessAllowed);

  return { user, partners };
};
